import React, { useState } from 'react';
import { useMutation, useQuery } from '@apollo/client';
import { ProfFields } from './ProfFields';
import { createUserMutationOptions } from '../../../../graphql/mutation/user/eleve/createUserMutationOptions';
import { ADD_PROF } from '../../../../graphql/mutation/user/prof/prof';
import { profInit } from '../../../../types/user/prof.def';
import { addProfParams } from '../../../../helpers/user/addProfParams';
import { QueryUserClasseQuery } from '../../../../graphql/generated/graphql';
import { QUERY_USER_CLASSE } from '../../../../graphql/query/user/queryUserAccount';
import { LoadingContainer } from 'components/molecules/Loaders/LoadingContainer';
import { ErrorContainer } from 'components/organisms/Error/ErrorContainer';
import { GraphQLError } from 'graphql';
import { ButtonWithText } from '../../../atoms/Buttons/ButtonWithText';
import useStyle from './formCreateProf.style';
import { FlatIcon } from '../../../atoms/Icons/FlatIcon';
import { yellow } from '../../../../theme/colors';

const FormCreateProf = () => {
  const classes = useStyle();
  const [submitLoading, setSubmitLoading] = useState(false);
  const { data, loading: load, error } = useQuery<QueryUserClasseQuery>(
    QUERY_USER_CLASSE
  );
  const maClasse = data?.getUserClasse?.id;
  const [profForm, setForm] = useState({
    ...profInit
  });
  const [addProf] = useMutation(
    ADD_PROF,
    createUserMutationOptions({
      setForm
    })
  );

  const submit = async () => {
    setSubmitLoading(true);
    const profParams = addProfParams(profForm.values, maClasse);
    if (profForm.isValid) {
      await addProf({
        variables: profParams
      });
      setSubmitLoading(false);
    }
    setSubmitLoading(false);
  };

  if (load) return <LoadingContainer />;
  if (error)
    return (
      <ErrorContainer
        detailErr={
          new GraphQLError('Erreur dans la récupération de la classe.')
        }
      />
    );

  return (
    <>
      <div className={classes.alert}>
        <FlatIcon icon={'Warning'} color={yellow} />
        <p>
          ATTENTION ! Pour tout professeur qui a déjà un compte dans
          l'application (pilote ou binôme), veuillez nous contacter à{' '}
          <span className={classes.link}>contact@francechallenges.com</span>. En
          revanche, si le professeur n'a pas encore de compte dans l'app, vous
          pouvez le créer en utilisant le formulaire ci-dessous.
        </p>
      </div>
      <ProfFields profForm={profForm} setForm={setForm} />
      <div style={{ margin: 'auto' }}>
        <ButtonWithText
          content="Ajouter à la classe"
          onClick={submit}
          disabled={!profForm.isValid}
          icon={'Plus'}
          loading={submitLoading}
        />
      </div>
    </>
  );
};

export default FormCreateProf;
